module.exports = __webpack_public_path__ + "img/infobip.ef114828.png";